import React from "react";
import { Helmet } from "react-helmet-async";
import "./CustomerReview.css";

import cl1 from "../../Assets/CustomerReview/re1.jpeg";
import cl2 from "../../Assets/CustomerReview/re2.jpeg";
import cl3 from "../../Assets/CustomerReview/re3.jpeg";
import cl4 from "../../Assets/CustomerReview/re4.jpeg";
import cl5 from "../../Assets/CustomerReview/re5.jpeg";
import cl6 from "../../Assets/CustomerReview/re6.jpeg";
import cl7 from "../../Assets/CustomerReview/re7.jpeg";
import cl8 from "../../Assets/CustomerReview/re8.jpeg";
import cl9 from "../../Assets/CustomerReview/re9.jpeg";

const selfReviews = [
  { name: "Rahul Sharma", image: cl1, text: "The self-drive experience was seamless and smooth." },
  { name: "Priya Verma", image: cl4, text: "Very easy booking with clean cars." },
  { name: "Amit Patel", image: cl2, text: "Affordable and transparent pricing." },
  { name: "Sneha Gupta", image: cl5, text: "Perfect cars for long drives." },
  { name: "Vikas Yadav", image: cl6, text: "Professional and quick service." }
];

const driverReviews = [
  { name: "Manish Gupta", image: cl1, text: "Driver was very professional." },
  { name: "Simran Kaur", image: cl9, text: "Comfortable and safe ride." },
  { name: "Arjun Kapoor", image: cl3, text: "Smooth and stress-free journey." },
  { name: "Ritika Shah", image: cl7, text: "Very relaxing experience." },
  { name: "Deepak Mishra", image: cl8, text: "Driver was punctual and helpful." }
];

const CustomerReview = () => {

  // ✅ UPDATED SCHEMA WITH DOMAIN
  const reviewSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Shree Ram Car Rental",
    "url": "https://www.shreeramcarrental.com/reviews", // ✅ ADDED
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "15000"
    }
  };

  const ReviewGroup = ({ title, reviews, reverse }) => (
    <div className="review-group">
      <div className="group-header">
        <div className="line"></div>
        <h2 className="heading">{title}</h2>
        <div className="line"></div>
      </div>
      
      <div className={`marquee ${reverse ? 'reverse' : ''}`}>
        <div className="marquee-content">
          {[...reviews, ...reviews, ...reviews].map((review, index) => (
            <div key={index} className="review-card">
              <div className="quote-icon">“</div>

              <p className="review-text">{review.text}</p>

              <div className="review-bottom">
                <img 
                  src={review.image} 
                  alt={`${review.name} review - car rental Indore`} 
                  className="user-img" 
                  loading="lazy"
                />

                <div className="user-info">
                  <h3>{review.name}</h3>

                  <div className="stars">
                    {[...Array(5)].map((_, i) => (
                      <span key={i}>★</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <>
      {/* ✅ SEO UPDATED */}
      <Helmet>
        <title>Customer Reviews | Shree Ram Car Rental Indore</title>

        <meta 
          name="description" 
          content="Read real customer reviews of Shree Ram Car Rental Indore. Trusted self drive and taxi service with 4.9 rating." 
        />

        {/* ✅ CANONICAL */}
        <link rel="canonical" href="https://www.shreeramcarrental.com/reviews" />

        {/* ✅ SCHEMA */}
        <script type="application/ld+json">
          {JSON.stringify(reviewSchema)}
        </script>
      </Helmet>

      <div className="review-section">
        <div className="section-intro">
          <span className="subtitle">Testimonials</span>
          <h1>What Our Customers Say</h1>
        </div>

        <ReviewGroup title="Self Drive Experience" reviews={selfReviews} />
        <ReviewGroup title="Chauffeur Driven Service" reviews={driverReviews} reverse={true} />
      </div>
    </>
  );
};

export default CustomerReview;